import { memo } from 'react';
import { v4 } from 'uuid';
import { EventPanelMetadata } from '@mark43/cad-api';
import { Button, Menu, MenuContent, MenuTrigger, MenuItem } from '@cad-arc';
import { useIntegratedActionBroadcaster } from '../../action-broadcaster/use-integrated-action-broadcaster';
import { useCurrentUser } from '../../current-user/current-user';
import { useEventMetadataStore } from './event-metadata';
import { DISCIPLINE_LABEL_ENUM } from './constants';
import {
    logMissingParameterWarning,
    Discipline,
} from './helpers/pro-qa-buttons-helpers';

export const EventPanelFormOpenProQaSummaryButton = memo(
    function EventPanelFormOpenProQaSummaryButton({
        enabledDisciplines,
    }: {
        enabledDisciplines: Discipline[];
    }) {
        const { trigger } = useIntegratedActionBroadcaster();
        const currentUser = useCurrentUser();
        const { eventId, agencyEventNumber } =
            useEventMetadataStore().state.metadata ?? ({} as EventPanelMetadata);

        const openProQaSummary = (discipline: Discipline) => {
            if (!eventId) {
                logMissingParameterWarning('event ID');
                return;
            }

            if (!agencyEventNumber) {
                logMissingParameterWarning('incident number');
                return;
            }

            trigger([
                {
                    id: v4(),
                    targetWindowType: 'ROOT',
                    type: 'OPEN_PRO_QA_SUMMARY',
                    payload: {
                        type: discipline,
                        username: `${currentUser.firstName} ${currentUser.lastName}`,
                        incidentNumber: agencyEventNumber,
                    },
                },
            ]);
        };

        if (enabledDisciplines.length === 1) {
            return (
                <Button variant="ghost" onClick={() => openProQaSummary(enabledDisciplines[0])}>
                    ProQA Summary
                </Button>
            );
        }

        return (
            <Menu>
                <MenuTrigger asChild>
                    <Button variant="ghost" trailingVisual="Open">
                        ProQA Summary
                    </Button>
                </MenuTrigger>
                <MenuContent>
                    {enabledDisciplines.map((discipline) => (
                        <MenuItem key={discipline} onClick={() => openProQaSummary(discipline)}>
                            {DISCIPLINE_LABEL_ENUM[discipline].enhancementLabel}
                        </MenuItem>
                    ))}
                </MenuContent>
            </Menu>
        );
    }
);
